import { Button, Input } from 'antd'
import React from 'react'
import { Label } from 'reactstrap'
import './DoneStepPage.scss'

const DoneStepPage = () => {
    return (
        <div className='donestep-section'>
            <h1>Share your <strong>intro video.</strong></h1>
            <form>
                <div className="form-field">
                    <Label>Link to a short 60-second founder intro video (unlisted Youtube link)</Label>
                    <Input className="text-field-input"
                        placeholder="youtube.com/my-link "
                        name="youtube-link"
                        type="text" />
                </div>
                <Button
                    // loading={authLoading}
                    // disabled={!isEnabled}
                    // onClick={next}
                    className="submit-button"
                >
                    Submit
                </Button>
            </form>
        </div>
    )
}

export default DoneStepPage